// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpointsToArray, media } from '@leasen_nl/listo/src/helpers';
import { CategoryTitle, QuestionList, SubCategoryList } from '@leasen_nl/listo/src/components/faq';
import type {
  FAQCategoryWithCategories, FAQParent, FAQCategory, FAQItemInCategory,
} from '@leasen_nl/listo/src/types/faq';
import type { Theme } from '@types/index';
import Row from '../row';
import Column from '../column';

const SideColumn = styled<typeof Column, Theme, _>(Column)`
  > * {
    padding: 2rem 0;
  }

  ${media.lg(css`
    > * {
      padding: 0;
    }
  `)}
`;

type OwnProps = {|
  rootCategory: FAQCategoryWithCategories,
  parent: ?FAQParent,
|};

type Props = OwnProps;

const SubCategory = ({
  rootCategory,
  parent,
}: Props) => {
  // For now, render categories only one level deep
  let activeCategory = (rootCategory.categories || []).find((category: FAQCategory) => (
    category.active
  ));

  if (!activeCategory) {
    /**
     * This is the case where we have no active subcategory. In that case, use the rootCategory
     * to display the items that are directly under that category.
     */
    activeCategory = rootCategory;
  }

  return (
    <section>
      <Row>
        <Column width={1}>
          <CategoryTitle
            title={rootCategory.name}
            description={rootCategory.description}
            icon={rootCategory.icon}
          />
        </Column>
      </Row>
      <Row>
        <SideColumn
          width={breakpointsToArray({
            default: 12 / 12,
            lg: 4 / 12,
          })}
        >
          <SubCategoryList
            categories={(rootCategory.categories || []).map(
              (category: FAQCategory) => ({
                active: category.active,
                name: category.name,
                url: category.permalink,
              }),
            )}
            parentName={parent && parent.title}
            parentUrl={parent && parent.permalink}
          />
        </SideColumn>
        <Column
          width={breakpointsToArray({
            default: 12 / 12,
            lg: 8 / 12,
          })}
        >
          <QuestionList
            questions={(activeCategory.items || []).map((item: FAQItemInCategory) => ({
              question: item.post_title,
              url: item.permalink,
            }))}
          />
        </Column>
      </Row>
    </section>
  );
};

export default SubCategory;
